import {
  SET_REIMBURSEMENTREF,
  SET_PAYMENT_METHOD,
  SET_COPY_REIMBURSEMENTREF,
} from '../../ActionTypes'

export const setReimbursementRef = (reimbursementRef) => ({
  type: SET_REIMBURSEMENTREF,
  reimbursementRef,
})

export const setCopyReimbursementRef = (copyReimbursementRef) => ({
  type: SET_COPY_REIMBURSEMENTREF,
  copyReimbursementRef,
})
export const setPaymentMethod = (paymentMethod) => ({
  type: SET_PAYMENT_METHOD,
  paymentMethod,
})
